export default __webpack_public_path__ + "static/media/flag-egypt.80d618d1.svg";